import React from "react";

export const LazyCaseTagPage = React.lazy(
    () => import(/* webpackChunkName: "CaseTagPage" */ "./CaseTagPage")
);
